import {
    NotificationMethod,
} from "../../enums";
import {IGroup} from "../../interfaces/IGroup";
import {ITelegramParams} from "../../interfaces/ITelegramParams";
import {IMailParams} from "../../interfaces/IMailParams";

export const initialTelegramParams:ITelegramParams = {chatId: "", botToken: ""}
export const initialMailParams:IMailParams = {recipientsMails:[]}

export const initialGroupObj: IGroup = {
    name: "",
    params: initialTelegramParams,
    method: NotificationMethod.TELEGRAM

}